import OutOfStock from "./out-of-stock";

export default OutOfStock;